import { ChangeEvent } from '@bm-js/atlascloud-shared'
import { Editor } from '@tinymce/tinymce-react'
import { useRef } from 'react'

type Props = {
  value?: string
  onChange?: (e: ChangeEvent) => void
  name?: string
  label?: string
}

const RichTextInput = ({ value, onChange, name, label }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null)

  return (
    <>
      {!!label && <p className='m0 label light'>{label}</p>}
      {/* TODO: Externalize rich text editor to a single component */}
      <Editor
        onInit={(_, editor) => {
          ref.current = editor
        }}
        apiKey='8vx5y7rq8czx2uiyjxz384z1tgv52e698san9yj67z6h9z45'
        initialValue={value}
        onBlur={() => {
          const e = {
            target: {
              name: name || '',
              value: ref.current.getContent(),
            },
          }
          onChange?.(e)
        }}
        init={{
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],

          toolbar: 'blocks | bold italic underline link  | bullist numlist |',
        }}
      />
    </>
  )
}

export default RichTextInput
